import React from 'react';
import { GlassCard } from '@/components/ui/glass-card';
import { Quote } from 'lucide-react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel"
import Autoplay from "embla-carousel-autoplay"

const TestimonialCarousel = () => {
  const testimonials = [
    {
      name: "Natascha D.",
      text: "Man lernt sich in diesem Kurs endlich kennen und wertschätzen. Unglaubliche Energien durchströmen meinen Körper, ich habe das Gefühl leicht zu sein."
    },
    {
      name: "Ursula Z.",
      text: "Beim Kurs habe ich erkannt, dass alles was ich gefühlt und gesehen habe richtig war. Aber erst jetzt kann ich alles einordnen und verstehen. Ich bin froh, dass ich mich nicht von mir selbst und anderen abhalten ließ, den Kurs zu besuchen."
    },
    {
      name: "Martina S.",
      text: "Für diese Ausbildung musste ich so richtig über meinen Schatten springen. Ich war mir nicht sicher, ob das das Richtige für mich ist. Was soll ich sagen: 'Ich bin so froh es gewagt zu haben'. Es ist ok nicht alles zu sehen oder auf Anhieb zu erkennen, aber ich bin offen für alles was noch kommt."
    },
    {
      name: "Andrea R.",
      text: "Ich bin seit ich mich im Gedanken damit beschäftige die Ausbildung zu besuchen voll im Vertrauen das Richtige zu tun. Unklare Nebel lichten sich sehr rasch. Innere Ruhe, ein unbeschreibliches Liebesgefühl verspüre ich im ganzen Körper. Ich bin dankbar diese Gefühle nach einer Depression zu spüren ❣️"
    }
  ];

  const plugin = React.useRef(
    Autoplay({ delay: 5000, stopOnInteraction: true, stopOnMouseEnter: true })
  )

  return (
    <section className="py-20 bg-primary-lightest">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-primary-deep mb-4">
            Was unsere Teilnehmer sagen
          </h2>
          <p className="text-xl text-primary-deep max-w-3xl mx-auto">
            Erfahrungen und Testimonials von Absolventen der Prana Kundalini-Therapie® Ausbildung
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          <Carousel
            plugins={[plugin.current]}
            className="w-full"
            onMouseEnter={plugin.current.stop}
            onMouseLeave={plugin.current.reset}
            opts={{
              align: "start",
              loop: true,
            }}
          >
            <CarouselContent className="-ml-2 md:-ml-4">
              {testimonials.map((testimonial, index) => (
                <CarouselItem key={index} className="pl-2 md:pl-4 md:basis-1/2 lg:basis-1/2">
                  <GlassCard className="p-8 bg-white/90 border-white/30 hover:bg-white/95 transition-all duration-300 h-full">
                    <div className="relative h-full flex flex-col">
                      <Quote className="h-8 w-8 text-primary-main mb-4" />
                      <blockquote className="text-primary-deep leading-relaxed mb-6 grow">
                        "{testimonial.text}"
                      </blockquote>
                      <footer className="text-primary-main font-semibold">
                        — {testimonial.name}
                      </footer>
                    </div>
                  </GlassCard>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="hidden md:flex" />
            <CarouselNext className="hidden md:flex" />
          </Carousel>
        </div>
      </div>
    </section>
  );
};

export default TestimonialCarousel;